// extracted by mini-css-extract-plugin
export default {"title":"Courses_title__XwtXP","description":"Courses_description__KujZ0","button":"Courses_button__N0ztx","bottom":"Courses_bottom__vM0yw"};